// ----------------------------------------------------------------------
// Consultation types
export const CONSULTATION_TYPE_PERFORMANCE_ANXIETY =
  "performance-anxiety-consultation";
export const CONSULTATION_TYPE_PERFORMANCE_ANXIETY_FOLLOW_UP =
  "performance-anxiety-consultation";
export const CONSULTATION_TYPE_INSOMNIA = "insomnia-consultation";
export const CONSULTATION_TYPE_INSOMNIA_FOLLOW_UP =
  "insomnia-consultation-follow-up";

export const CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY = "pac";
export const CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP =
  "paf";
export const CONSULTATION_TYPE_ABBREVIATION_INSOMNIA = "inc";
export const CONSULTATION_TYPE_ABBREVIATION_INSOMNIA_FOLLOW_UP = "inf";
export const CONSULTATION_TYPE_ABBREVIATION_SCOPOLAMINE_ADDON = "sca";

export const VISIT_TYPE_PERFORMANCE_ANXIETY = "PA";
export const VISIT_TYPE_PERFORMANCE_ANXIETY_FOLLOW_UP = "PAF";
export const VISIT_TYPE_INSOMNIA = "IN";
export const VISIT_TYPE_INSOMNIA_FOLLOW_UP = "INF";

// ----------------------------------------------------------------------
// Doctor Visit Statuses
export const DOCTOR_VISIT_STATUS_AWAITING_REPLY = "PR";
export const DOCTOR_VISIT_STATUS_CANCELED = "CL";
export const DOCTOR_VISIT_STATUS_CLOSED_COMPLETE = "CC";
export const DOCTOR_VISIT_STATUS_CLOSED_DUPLICATE = "CD";
export const DOCTOR_VISIT_STATUS_CLOSED_ERROR = "CE";
export const DOCTOR_VISIT_STATUS_CLOSED_OTHER = "CO";
export const DOCTOR_VISIT_STATUS_CLOSED_PAYMENT_UNCOLLECTABLE = "CPU";
export const DOCTOR_VISIT_STATUS_CLOSED_REFERRAL_PRIMARY = "CP";
export const DOCTOR_VISIT_STATUS_CLOSED_REFERRAL_URGENT = "CU";
export const DOCTOR_VISIT_STATUS_CLOSED_REFUNDED = "CR";
export const DOCTOR_VISIT_STATUS_CLOSED_SPAM = "CS";
export const DOCTOR_VISIT_STATUS_PENDING = "P";
export const DOCTOR_VISIT_STATUS_PENDING_PAYMENT = "PA";
export const DOCTOR_VISIT_STATUS_PENDING_PHOTOS = "PP";
export const DOCTOR_VISIT_STATUS_PENDING_REVIEW_ADMIN = "PRAD";
export const DOCTOR_VISIT_STATUS_PENDING_VERIFICATION = "PV";
export const DOCTOR_VISIT_STATUS_READY = "R";

// ----------------------------------------------------------------------
// Order Types
// Performance Anxiety
export const ORDER_TYPE_PROP_2_PACK = "prop-2-pack";
export const ORDER_TYPE_PROP_2_PACK_REFILL = "prop-2-pack-refill";
export const ORDER_TYPE_PROP_2_PACK_FOLLOW_UP = "prop-2-pack-follow-up";

export const ORDER_TYPE_PROP_1_PACK = "prop-1-pack";
export const ORDER_TYPE_PROP_1_PACK_REFILL = "prop-1-pack-refill";
export const ORDER_TYPE_PROP_1_PACK_FOLLOW_UP = "prop-1-pack-follow-up";

export const ORDER_TYPE_PROP_VISIT_ONLY = "prop-visit-only";
export const ORDER_TYPE_PROP_VISIT_ONLY_FOLLOW_UP = "prop-visit-only-follow-up";

// Insomnia
export const ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_MONTHLY =
  "sleep-rx-monthly";
export const ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_QUARTERLY =
  "sleep-rx-quarterly";
export const ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_SEMIANNUAL =
  "sleep-rx-semiannual";
export const ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_FOLLOW_UP =
  "sleep-rx-follow-up";

export const ORDER_TYPE_SLEEP_MEMBERSHIP_VISIT_ONLY_MONTHLY =
  "sleep-rx-visit-only-monthly";
export const ORDER_TYPE_SLEEP_MEMBERSHIP_VISIT_ONLY_QUARTERLY =
  "sleep-rx-visit-only-quarterly";
export const ORDER_TYPE_SLEEP_MEMBERSHIP_VISIT_ONLY_SEMIANNUAL =
  "sleep-rx-visit-only-semiannual";
export const ORDER_TYPE_SLEEP_MEMBERSHIP_VISIT_ONLY_FOLLOW_UP =
  "sleep-rx-visit-only-follow-up";

export const ORDER_TYPE_SLEEP_RX_TRIAL_VISIT_ONLY_ONE_MONTH =
  "sleep-rx-visit-only-trial-one-month";
export const ORDER_TYPE_SLEEP_RX_TRIAL_VISIT_ONLY_TWO_MONTHS =
  "sleep-rx-visit-only-trial-two-month";
export const ORDER_TYPE_SLEEP_RX_TRIAL_MAIL_ORDER_ONE_MONTH =
  "sleep-rx-trial-one-month";
export const ORDER_TYPE_SLEEP_RX_TRIAL_MAIL_ORDER_TWO_MONTHS =
  "sleep-rx-trial-two-months";

// Addons
export const ORDER_TYPE_SCOPOLAMINE_ADDON_4_PACK_MAIL_ORDER =
  "scop-addon-4-pack-mail-order";
export const ORDER_TYPE_SCOPOLAMINE_ADDON_10_PACK_MAIL_ORDER =
  "scop-addon-10-pack-mail-order";
export const ORDER_TYPE_SCOPOLAMINE_ADDON_4_PACK_VISIT_ONLY =
  "scop-addon-4-pack-visit-only";

// ----------------------------------------------------------------------

// BB Prices
export const PRICE_PROP_2_PACK = 89;
export const PRICE_PROP_2_PACK_REFILL = 65;
export const PRICE_PROP_2_PACK_FOLLOW_UP = 65;
export const PRICE_PROP_1_PACK = 69;
export const PRICE_PROP_1_PACK_REFILL = 45;
export const PRICE_PROP_1_PACK_FOLLOW_UP = 45;
export const PRICE_PROP_VISIT_ONLY = 59;
export const PRICE_PROP_VISIT_ONLY_FOLLOW_UP = 49;

export const PRICE_ONLINE_VISIT_FEE_FIRST_VISIT_PA = 49;
export const PRICE_ONLINE_VISIT_FEE_FOLLOW_UP_PA = 25;

// Scopolamine Prices
export const PRICE_SCOPOLAMINE_ADDON_4_PACK_MAIL_ORDER = 30;
export const PRICE_SCOPOLAMINE_ADDON_10_PACK_MAIL_ORDER = 50;
export const PRICE_SCOPOLAMINE_ADDON_4_PACK_VISIT_ONLY = 10;

// Sleep Prices
// Mail Order Recurring
export const PRICE_SLEEP_MEMBERSHIP_MONTHLY = 89;
export const PRICE_SLEEP_MEMBERSHIP_QUARTERLY = 209;
export const PRICE_SLEEP_MEMBERSHIP_SEMIANNUAL = 469;
export const PRICE_SLEEP_MEMBERSHIP_MONTHLY_PER_MONTH =
  PRICE_SLEEP_MEMBERSHIP_MONTHLY / 1;
export const PRICE_SLEEP_MEMBERSHIP_QUARTERLY_PER_MONTH = Math.round(
  PRICE_SLEEP_MEMBERSHIP_QUARTERLY / 3
);
export const PRICE_SLEEP_MEMBERSHIP_SEMIANNUAL_PER_MONTH = Math.round(
  PRICE_SLEEP_MEMBERSHIP_SEMIANNUAL / 6
);
// Visit Only Recurring
export const PRICE_SLEEP_MEMBERSHIP_VISIT_ONLY_MONTHLY = 69;
export const PRICE_SLEEP_MEMBERSHIP_VISIT_ONLY_QUARTERLY = 169;
export const PRICE_SLEEP_MEMBERSHIP_VISIT_ONLY_SEMIANNUAL = 329;
export const PRICE_SLEEP_MEMBERSHIP_VISIT_ONLY_MONTHLY_PER_MONTH = 69;
export const PRICE_SLEEP_MEMBERSHIP_VISIT_ONLY_QUARTERLY_PER_MONTH = Math.round(
  PRICE_SLEEP_MEMBERSHIP_VISIT_ONLY_QUARTERLY / 3
);
export const PRICE_SLEEP_MEMBERSHIP_VISIT_ONLY_SEMIANNUAL_PER_MONTH =
  Math.round(PRICE_SLEEP_MEMBERSHIP_VISIT_ONLY_SEMIANNUAL / 6);

// Non-Recurring
export const PRICE_SLEEP_TRIAL_MAIL_ORDER_ONE_MONTH = 129;
export const PRICE_SLEEP_TRIAL_VISIT_ONLY_ONE_MONTH = 99;

// Daily Prices
function getDailyCost(bulkCost, numDays) {
  return (Number(bulkCost) / numDays).toFixed(2);
}
export const PRICE_SLEEP_MEMBERSHIP_MONTHLY_PER_DAY = getDailyCost(
  PRICE_SLEEP_MEMBERSHIP_MONTHLY,
  1 * 30
);
export const PRICE_SLEEP_MEMBERSHIP_QUARTERLY_PER_DAY = getDailyCost(
  PRICE_SLEEP_MEMBERSHIP_QUARTERLY,
  3 * 30
);
export const PRICE_SLEEP_MEMBERSHIP_SEMIANNUAL_PER_DAY = getDailyCost(
  PRICE_SLEEP_MEMBERSHIP_SEMIANNUAL,
  6 * 30
);
export const PRICE_SLEEP_MEMBERSHIP_VISIT_ONLY_MONTHLY_PER_DAY = getDailyCost(
  PRICE_SLEEP_MEMBERSHIP_VISIT_ONLY_MONTHLY,
  1 * 30
);
export const PRICE_SLEEP_MEMBERSHIP_VISIT_ONLY_QUARTERLY_PER_DAY = getDailyCost(
  PRICE_SLEEP_MEMBERSHIP_VISIT_ONLY_QUARTERLY,
  3 * 30
);
export const PRICE_SLEEP_MEMBERSHIP_VISIT_ONLY_SEMIANNUAL_PER_DAY =
  getDailyCost(PRICE_SLEEP_MEMBERSHIP_VISIT_ONLY_SEMIANNUAL, 6 * 30);
export const PRICE_SLEEP_TRIAL_MAIL_ORDER_ONE_MONTH_PER_DAY = getDailyCost(
  PRICE_SLEEP_TRIAL_MAIL_ORDER_ONE_MONTH,
  1 * 30
);
export const PRICE_SLEEP_TRIAL_VISIT_ONLY_ONE_MONTH_PER_DAY = getDailyCost(
  PRICE_SLEEP_TRIAL_VISIT_ONLY_ONE_MONTH,
  1 * 30
);

// ----------------------------------------------------------------------
// Pharmacy constants

export const PHARMACY_KICK_MAIL_ORDER = "Kick Pharmacy";

export const FILL_PHARMACY_ID_TRUEPILL = "TP";
export const FILL_PHARMACY_ID_GOGOMEDS = "GGM";
export const FILL_PHARMACY_ID_TRANSITIONS_PHARMACY = "TRNS";
export const FILL_PHARMACY_ID_DOSESPOT_PICKUP = "DS";
export const FILL_PHARMACY_ID_SCRIPTSURE_PICKUP = "SS";

export const FILL_REQUEST_STATUS_NEW = "N";
export const FILL_REQUEST_STATUS_SENT = "S";
export const FILL_REQUEST_STATUS_SENDING_ERROR = "SE";
export const FILL_REQUEST_STATUS_FILLED = "F";
export const FILL_REQUEST_STATUS_ERROR = "E";
export const FILL_REQUEST_STATUS_CANCELLED = "X";
export const FILL_REQUEST_STATUS_PROCESSING = "P";
export const FILL_REQUEST_STATUS_DELETED = "D";
export const FILL_REQUEST_STATUS_INACTIVE = "I";

// ----------------------------------------------------------------------
// MedicationConstants

// Propranolol
export const PROPRANOLOL_10MG_TAB = "PROPRANOLOL_10MG_TAB";
export const PROPRANOLOL_20MG_TAB = "PROPRANOLOL_20MG_TAB";
export const PROPRANOLOL_40MG_TAB = "PROPRANOLOL_40MG_TAB";

// Atenolol
export const ATENOLOL_25MG_TAB = "ATENOLOL_25MG_TAB";
export const ATENOLOL_50MG_TAB = "ATENOLOL_50MG_TAB";

// Doxepin
export const DOXEPIN_3MG_TAB = "DOXEPIN_3MG_TAB";
export const DOXEPIN_3MG_TAB_MONTH = "DOXEPIN_3MG_TAB_MONTH";
export const DOXEPIN_3MG_TAB_TRIAL = "DOXEPIN_3MG_TAB_TRIAL";
export const DOXEPIN_3MG_TAB_TWO_MONTHS = "DOXEPIN_3MG_TAB_TWO_MONTHS";
export const DOXEPIN_3MG_TAB_AUTOSHIP = "DOXEPIN_3MG_TAB_AUTOSHIP";

export const DOXEPIN_6MG_TAB = "DOXEPIN_6MG_TAB";
export const DOXEPIN_6MG_TAB_MONTH = "DOXEPIN_6MG_TAB_MONTH";
export const DOXEPIN_6MG_TAB_TRIAL = "DOXEPIN_6MG_TAB_TRIAL";
export const DOXEPIN_6MG_TAB_TWO_MONTHS = "DOXEPIN_6MG_TAB_TWO_MONTHS";
export const DOXEPIN_6MG_TAB_AUTOSHIP = "DOXEPIN_6MG_TAB_AUTOSHIP";

// Gabapentin
export const GABAPENTIN_100MG_CAP = "GABAPENTIN_100MG_CAP";
export const GABAPENTIN_100MG_CAP_TRIAL = "GABAPENTIN_100MG_CAP_TRIAL";
export const GABAPENTIN_100MG_CAP_MONTH = "GABAPENTIN_100MG_CAP_MONTH";
export const GABAPENTIN_100MG_CAP_TWO_MONTHS =
  "GABAPENTIN_100MG_CAP_TWO_MONTHS";
export const GABAPENTIN_100MG_CAP_AUTOSHIP = "GABAPENTIN_100MG_CAP_AUTOSHIP";

export const GABAPENTIN_300MG_CAP = "GABAPENTIN_300MG_CAP";
export const GABAPENTIN_300MG_CAP_TRIAL = "GABAPENTIN_300MG_CAP_TRIAL";
export const GABAPENTIN_300MG_CAP_MONTH = "GABAPENTIN_300MG_CAP_MONTH";
export const GABAPENTIN_300MG_CAP_TWO_MONTHS =
  "GABAPENTIN_300MG_CAP_TWO_MONTHS";
export const GABAPENTIN_300MG_CAP_AUTOSHIP = "GABAPENTIN_300MG_CAP_AUTOSHIP";

export const GABAPENTIN_400MG_CAP = "GABAPENTIN_400MG_CAP";
export const GABAPENTIN_400MG_CAP_TRIAL = "GABAPENTIN_400MG_CAP_TRIAL";
export const GABAPENTIN_400MG_CAP_MONTH = "GABAPENTIN_400MG_CAP_MONTH";
export const GABAPENTIN_400MG_CAP_TWO_MONTHS =
  "GABAPENTIN_400MG_CAP_TWO_MONTHS";
export const GABAPENTIN_400MG_CAP_AUTOSHIP = "GABAPENTIN_400MG_CAP_AUTOSHIP";

// Guanfacine
export const GUANFACINE_1MG_TAB = "GUANFACINE_1MG_TAB";
export const GUANFACINE_1MG_TAB_TRIAL = "GUANFACINE_1MG_TAB_TRIAL";
export const GUANFACINE_1MG_TAB_MONTH = "GUANFACINE_1MG_TAB_MONTH";
export const GUANFACINE_1MG_TAB_TWO_MONTHS = "GUANFACINE_1MG_TAB_TWO_MONTHS";
export const GUANFACINE_1MG_TAB_AUTOSHIP = "GUANFACINE_1MG_TAB_AUTOSHIP";

// Trazodone
export const TRAZODONE_50MG_TAB = "TRAZODONE_50MG_TAB";
export const TRAZODONE_50MG_TAB_MONTH = "TRAZODONE_50MG_TAB_MONTH";
export const TRAZODONE_50MG_TAB_TRIAL = "TRAZODONE_50MG_TAB_TRIAL";
export const TRAZODONE_50MG_TAB_TWO_MONTHS = "TRAZODONE_50MG_TAB_TWO_MONTHS";
export const TRAZODONE_50MG_TAB_AUTOSHIP = "TRAZODONE_50MG_TAB_AUTOSHIP";

export const TRAZODONE_100MG_TAB = "TRAZODONE_100MG_TAB";
export const TRAZODONE_100MG_TAB_MONTH = "TRAZODONE_100MG_TAB_MONTH";
export const TRAZODONE_100MG_TAB_TRIAL = "TRAZODONE_100MG_TAB_TRIAL";
export const TRAZODONE_100MG_TAB_TWO_MONTHS = "TRAZODONE_100MG_TAB_TWO_MONTHS";
export const TRAZODONE_100MG_TAB_AUTOSHIP = "TRAZODONE_100MG_TAB_AUTOSHIP";

export const TRAZODONE_150MG_TAB = "TRAZODONE_150MG_TAB";
export const TRAZODONE_150MG_TAB_MONTH = "TRAZODONE_150MG_TAB_MONTH";
export const TRAZODONE_150MG_TAB_TRIAL = "TRAZODONE_150MG_TAB_TRIAL";
export const TRAZODONE_150MG_TAB_TWO_MONTHS = "TRAZODONE_150MG_TAB_TWO_MONTHS";
export const TRAZODONE_150MG_TAB_AUTOSHIP = "TRAZODONE_150MG_TAB_AUTOSHIP";

// Hydroxyzine
export const HYDROXYZINE_HYDROCHLORIDE_10MG_TAB =
  "HYDROXYZINE_HYDROCHLORIDE_10MG_TAB";
export const HYDROXYZINE_HYDROCHLORIDE_10MG_TAB_MONTH =
  "HYDROXYZINE_HYDROCHLORIDE_10MG_TAB_MONTH";
export const HYDROXYZINE_HYDROCHLORIDE_10MG_TAB_TRIAL =
  "HYDROXYZINE_HYDROCHLORIDE_10MG_TAB_TRIAL";
export const HYDROXYZINE_HYDROCHLORIDE_10MG_TAB_TWO_MONTHS =
  "HYDROXYZINE_HYDROCHLORIDE_10MG_TAB_TWO_MONTHS";
export const HYDROXYZINE_HYDROCHLORIDE_10MG_TAB_AUTOSHIP =
  "HYDROXYZINE_HYDROCHLORIDE_10MG_TAB_AUTOSHIP";

export const HYDROXYZINE_HYDROCHLORIDE_25MG_TAB =
  "HYDROXYZINE_HYDROCHLORIDE_25MG_TAB";
export const HYDROXYZINE_HYDROCHLORIDE_25MG_TAB_MONTH =
  "HYDROXYZINE_HYDROCHLORIDE_25MG_TAB_MONTH";
export const HYDROXYZINE_HYDROCHLORIDE_25MG_TAB_TRIAL =
  "HYDROXYZINE_HYDROCHLORIDE_25MG_TAB_TRIAL";
export const HYDROXYZINE_HYDROCHLORIDE_25MG_TAB_TWO_MONTHS =
  "HYDROXYZINE_HYDROCHLORIDE_25MG_TAB_TWO_MONTHS";
export const HYDROXYZINE_HYDROCHLORIDE_25MG_TAB_AUTOSHIP =
  "HYDROXYZINE_HYDROCHLORIDE_25MG_TAB_AUTOSHIP";

export const HYDROXYZINE_HYDROCHLORIDE_50MG_TAB =
  "HYDROXYZINE_HYDROCHLORIDE_50MG_TAB";
export const HYDROXYZINE_HYDROCHLORIDE_50MG_TAB_MONTH =
  "HYDROXYZINE_HYDROCHLORIDE_50MG_TAB_MONTH";
export const HYDROXYZINE_HYDROCHLORIDE_50MG_TAB_TRIAL =
  "HYDROXYZINE_HYDROCHLORIDE_50MG_TAB_TRIAL";
export const HYDROXYZINE_HYDROCHLORIDE_50MG_TAB_TWO_MONTHS =
  "HYDROXYZINE_HYDROCHLORIDE_50MG_TAB_TWO_MONTHS";
export const HYDROXYZINE_HYDROCHLORIDE_50MG_TAB_AUTOSHIP =
  "HYDROXYZINE_HYDROCHLORIDE_50MG_TAB_AUTOSHIP";

// Cyclobenzaprine
export const CYCLOBENZAPRINE_5MG_TAB = "CYCLOBENZAPRINE_5MG_TAB";
export const CYCLOBENZAPRINE_5MG_TAB_TRIAL = "CYCLOBENZAPRINE_5MG_TAB_TRIAL";
export const CYCLOBENZAPRINE_5MG_TAB_MONTH = "CYCLOBENZAPRINE_5MG_TAB_MONTH";
export const CYCLOBENZAPRINE_5MG_TAB_TWO_MONTHS =
  "CYCLOBENZAPRINE_5MG_TAB_TWO_MONTHS";
export const CYCLOBENZAPRINE_5MG_TAB_AUTOSHIP =
  "CYCLOBENZAPRINE_5MG_TAB_AUTOSHIP";

export const CYCLOBENZAPRINE_7PT5MG_TAB = "CYCLOBENZAPRINE_7PT5MG_TAB";
export const CYCLOBENZAPRINE_7PT5MG_TAB_MONTH =
  "CYCLOBENZAPRINE_7PT5MG_TAB_MONTH";
export const CYCLOBENZAPRINE_7PT5MG_TAB_TRIAL =
  "CYCLOBENZAPRINE_7PT5MG_TAB_TRIAL";
export const CYCLOBENZAPRINE_7PT5MG_TAB_TWO_MONTHS =
  "CYCLOBENZAPRINE_7PT5MG_TAB_TWO_MONTHS";
export const CYCLOBENZAPRINE_7PT5MG_TAB_AUTOSHIP =
  "CYCLOBENZAPRINE_7PT5MG_TAB_AUTOSHIP";

export const CYCLOBENZAPRINE_10MG_TAB = "CYCLOBENZAPRINE_10MG_TAB";
export const CYCLOBENZAPRINE_10MG_TAB_MONTH = "CYCLOBENZAPRINE_10MG_TAB_MONTH";
export const CYCLOBENZAPRINE_10MG_TAB_TRIAL = "CYCLOBENZAPRINE_10MG_TAB_TRIAL";
export const CYCLOBENZAPRINE_10MG_TAB_TWO_MONTHS =
  "CYCLOBENZAPRINE_10MG_TAB_TWO_MONTHS";
export const CYCLOBENZAPRINE_10MG_TAB_AUTOSHIP =
  "CYCLOBENZAPRINE_10MG_TAB_AUTOSHIP";

// Quetiapine
export const QUETIAPINE_25MG_TAB = "QUETIAPINE_25MG_TAB";
export const QUETIAPINE_25MG_TAB_TRIAL = "QUETIAPINE_25MG_TAB_TRIAL";
export const QUETIAPINE_25MG_TAB_MONTH = "QUETIAPINE_25MG_TAB_MONTH";
export const QUETIAPINE_25MG_TAB_TWO_MONTHS = "QUETIAPINE_25MG_TAB_TWO_MONTHS";
export const QUETIAPINE_25MG_TAB_AUTOSHIP = "QUETIAPINE_25MG_TAB_AUTOSHIP";

// Ramelteon
export const RAMELTEON_8MG_TAB = "RAMELTEON_8MG_TAB";
export const RAMELTEON_8MG_TAB_TRIAL = "RAMELTEON_8MG_TAB_TRIAL";
export const RAMELTEON_8MG_TAB_MONTH = "RAMELTEON_8MG_TAB_MONTH";
export const RAMELTEON_8MG_TAB_TWO_MONTHS = "RAMELTEON_8MG_TAB_TWO_MONTHS";
export const RAMELTEON_8MG_TAB_AUTOSHIP = "RAMELTEON_8MG_TAB_AUTOSHIP";

// Scopolamine
export const SCOPOLAMINE_1MG_PATCH_4_PACK = "SCOPOLAMINE_1MG_PATCH_4_PACK";
export const SCOPOLAMINE_1MG_PATCH_10_PACK = "SCOPOLAMINE_1MG_PATCH_10_PACK";

// ----------------------------------------------------------------------
// URL constants

export const URL_KICK_WEBSITE = "https://www.gokick.com";
export const URL_KICK_WEBSITE_PATIENT_PORTAL = "https://www.gokick.com/me";

// ----------------------------------------------------------------------

// Medication Dosages
const medicationDosages = [
  {
    medication: "Cyclobenzaprine",
    medicationConstant: CYCLOBENZAPRINE_5MG_TAB,
    medicationFriendlyDosage: "Low",
    dosage: "5mg",
  },
  {
    medication: "Cyclobenzaprine",
    medicationConstant: CYCLOBENZAPRINE_7PT5MG_TAB,
    medicationFriendlyDosage: "Moderate",
    dosage: "7.5mg",
  },
  {
    medication: "Cyclobenzaprine",
    medicationConstant: CYCLOBENZAPRINE_10MG_TAB,
    medicationFriendlyDosage: "High",
    dosage: "10mg",
  },
  {
    medication: "Doxepin",
    medicationConstant: DOXEPIN_3MG_TAB,
    medicationFriendlyDosage: "Low",
    dosage: "3mg",
  },
  {
    medication: "Doxepin",
    medicationConstant: DOXEPIN_6MG_TAB,
    medicationFriendlyDosage: "Moderate",
    dosage: "6mg",
  },
  {
    medication: "Gabapentin",
    medicationConstant: GABAPENTIN_100MG_CAP,
    medicationFriendlyDosage: "Low",
    dosage: "100mg",
    formFactor: "Cap",
  },
  {
    medication: "Gabapentin",
    medicationConstant: GABAPENTIN_300MG_CAP,
    medicationFriendlyDosage: "Moderate",
    dosage: "300mg",
    formFactor: "Cap",
  },
  {
    medication: "Gabapentin",
    medicationConstant: GABAPENTIN_400MG_CAP,
    medicationFriendlyDosage: "High",
    dosage: "400mg",
    formFactor: "Cap",
  },
  {
    medication: "Guanfacine",
    medicationConstant: GUANFACINE_1MG_TAB,
    medicationFriendlyDosage: "low",
    dosage: "1mg",
    formFactor: "Tab",
  },
  {
    medication: "Hydroxyzine",
    medicationConstant: HYDROXYZINE_HYDROCHLORIDE_10MG_TAB,
    medicationFriendlyDosage: "Low",
    dosage: "10mg",
  },
  {
    medication: "Hydroxyzine",
    medicationConstant: HYDROXYZINE_HYDROCHLORIDE_25MG_TAB,
    medicationFriendlyDosage: "Moderate",
    dosage: "25mg",
  },
  {
    medication: "Hydroxyzine",
    medicationConstant: HYDROXYZINE_HYDROCHLORIDE_50MG_TAB,
    medicationFriendlyDosage: "High",
    dosage: "50mg",
  },
  {
    medication: "Quetiapine",
    medicationConstant: QUETIAPINE_25MG_TAB,
    medicationFriendlyDosage: "low",
    dosage: "25mg",
  },
  {
    medication: "Ramelteon",
    medicationConstant: RAMELTEON_8MG_TAB,
    medicationFriendlyDosage: "Moderate",
    dosage: "8mg",
  },
  {
    medication: "Trazodone",
    medicationConstant: TRAZODONE_50MG_TAB,
    medicationFriendlyDosage: "Low",
    dosage: "50mg",
  },
  {
    medication: "Trazodone",
    medicationConstant: TRAZODONE_100MG_TAB,
    medicationFriendlyDosage: "Moderate",
    dosage: "100mg",
  },
  {
    medication: "Trazodone",
    medicationConstant: TRAZODONE_150MG_TAB,
    medicationFriendlyDosage: "High",
    dosage: "150mg",
  },
];

function createStandardTrialMed(med) {
  return {
    ...med,
    quantityDescription: `Trial (14 ${med.formFactor || "Tab"}s)`,
    quantity: 14,
    refills: 1,
    patientDirections: "",
    icon: "trial",
  };
}
function createStandardOneMonthMed(med) {
  return {
    ...med,
    quantityDescription: `Month (30 ${med.formFactor || "Tab"}s)`,
    quantity: 30,
    refills: 1,
    patientDirections: "",
    icon: "month",
  };
}
function createStandardTwoMonthMed(med) {
  return {
    ...med,
    quantityDescription: `Two Months (60 ${med.formFactor || "Tab"}s)`,
    quantity: 60,
    refills: 1,
    patientDirections: "",
    icon: "month",
  };
}
function createStandardAutoshipMed(med, numRefills) {
  return {
    ...med,
    quantityDescription: `Six Months - (30 ${med.formFactor || "Tab"}s x 6)`,
    quantity: 30,
    refills: numRefills,
    patientDirections: "",
    icon: "month",
    autoship: true,
  };
}

export const MAP_SLEEP_MED_CONSTANTS_TO_DISPLAY = {};
medicationDosages.forEach((med) => {
  MAP_SLEEP_MED_CONSTANTS_TO_DISPLAY[`${med.medicationConstant}_TRIAL`] =
    createStandardTrialMed(med);
});
medicationDosages.forEach((med) => {
  MAP_SLEEP_MED_CONSTANTS_TO_DISPLAY[`${med.medicationConstant}_MONTH`] =
    createStandardOneMonthMed(med);
});
medicationDosages.forEach((med) => {
  MAP_SLEEP_MED_CONSTANTS_TO_DISPLAY[`${med.medicationConstant}_TWO_MONTHS`] =
    createStandardTwoMonthMed(med);
});
medicationDosages.forEach((med) => {
  MAP_SLEEP_MED_CONSTANTS_TO_DISPLAY[`${med.medicationConstant}_AUTOSHIP`] =
    createStandardAutoshipMed(med, 6);
});

// Shipping Options
export const SHIPPING_METHOD_STANDARD = "standard";
export const SHIPPING_METHOD_TWO_DAY = "fedex-two-day";
export const SHIPPING_METHOD_TWO_DAY_PRICE = 15;

// Colors
export const COLOR_KICK_NAVY = "#1e2347";
export const COLOR_KICK_YELLOW = "#ffdd00";
export const COLOR_KICK_PINK = "#ffb7ad";
export const COLOR_KICK_SLATE = "#8096ab";
export const COLOR_KICK_BLUE = "#3f3f82";
export const COLOR_KICK_BLUE_LIGHTENED = "#5050A4";
export const COLOR_KICK_GREEN = "#30544f";
export const COLOR_KICK_RED = "#f25930";

export const COLOR_KICK_LIGHT_YELLOW = "#fff7e5";
export const COLOR_KICK_LIGHT_PINK = "#fff2f0";
export const COLOR_KICK_LIGHT_SLATE = "#f7fcff";
export const COLOR_KICK_LIGHT_BLUE = "#f4f2f9";
export const COLOR_KICK_LIGHT_GREEN = "#f2f9f7";
export const COLOR_KICK_LIGHT_TAN = "#f9f9f9";

export const COLOR_KICK_LIGHT_GREY = "#e5e5e5";

export const DB_STATUS_ACTIVE = "A";
export const DB_STATUS_CANCELED = "C";

export const onePackBBRxValues = {
  refills: 3,
  quantity: 24,
  daysSupply: 12,
};
export const twoPackBBRxValues = {
  refills: 3,
  quantity: 48,
  daysSupply: 24,
};
export const visitOnlyBBRxValues = {
  refills: 1,
  quantity: 24,
  daysSupply: 12,
};
export const fourPackScopRxValues = {
  refills: 3,
  quantity: 4,
  daysSupply: 4,
};
export const tenPackScopRxValues = {
  refills: 3,
  quantity: 10,
  daysSupply: 10,
};
export const fourPackScopVisitOnlyRxValues = {
  refills: 1,
  quantity: 4,
  daysSupply: 4,
};

export const errorMessages = {
  PHONE_NUMBER_ALREADY_EXISTS: "Phone number already exists",
};
